module.exports = __webpack_public_path__ + "static/2c4f6a99-1274-42cd-8d14-fecf6ae449a4-4f23087291cd9da8bb35e427c14b2ee0.ttf";